import React from 'react';
import { Box, Typography, Container } from '@mui/material';

export default function PrivacyPolicy() {
    return (
        <Box sx={{ py: { xs: 4, md: 6 }, bgcolor: '#f8f9fa' }}>
            <Container maxWidth="md">
                <Box sx={{ bgcolor: 'white', borderRadius: 2, p: { xs: 3, md: 5 }, boxShadow: 1 }}>
                    <Typography variant="h3" fontWeight="bold" sx={{ mb: 3, color: '#1e293b' }}>
                        Privacy Policy
                    </Typography>

                    <Typography variant="body2" sx={{ mb: 4, color: '#64748b' }}>
                        Last updated: {new Date().toLocaleDateString('en-EU')}
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        1. Controller Information
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        MeetMyBot is the data controller responsible for your personal data. You can contact us at:
                        <br />
                        Email: contact@eternity.ac
                        <br />
                        Address: [Your registered business address in EU]
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        2. Personal Data We Collect
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.7 }}>
                        We collect and process the following categories of personal data:
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7, pl: 2 }}>
                        • Contact information: name, email address, phone number<br />
                        • Technical data: IP address, browser type, device information<br />
                        • Usage data: pages visited, time spent, interactions with our AI clone<br />
                        • Communication data: messages sent through our contact form or chat interface<br />
                        • Cookie data: preferences, session information, analytics data
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        3. Legal Basis for Processing
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        We process your personal data based on the following legal grounds under Article 6 of the GDPR:
                        <br />
                        • Consent: When you explicitly consent to processing (e.g., marketing communications)
                        <br />
                        • Contract performance: To provide our AI clone services
                        <br />
                        • Legitimate interests: To improve our services and ensure security
                        <br />
                        • Legal obligations: To comply with applicable laws and regulations
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        4. How We Use Your Data
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        We use your personal data for the following purposes:
                        <br />
                        • Providing and maintaining our AI clone services
                        <br />
                        • Processing your inquiries and providing customer support
                        <br />
                        • Personalizing your experience with our digital clone technology
                        <br />
                        • Analyzing usage patterns to improve our services
                        <br />
                        • Sending service-related communications
                        <br />
                        • Ensuring the security and integrity of our systems
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        5. Data Sharing and Third Parties
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        We may share your personal data with:
                        <br />
                        • Eternity.ac: Our technology provider for AI clone functionality
                        <br />
                        • Salesforce: For CRM and customer relationship management
                        <br />
                        • Cloud service providers: For hosting and data storage (AWS, Google Cloud)
                        <br />
                        • Analytics providers: Google Analytics for usage analysis
                        <br />
                        • Legal authorities: When required by law or to protect our rights
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        6. International Data Transfers
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        Some of our service providers are located outside the European Economic Area (EEA). We ensure adequate protection through:
                        <br />
                        • EU-US Data Privacy Framework adequacy decision
                        <br />
                        • Standard Contractual Clauses approved by the European Commission
                        <br />
                        • Binding Corporate Rules where applicable
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        7. Data Retention
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        We retain your personal data only as long as necessary for the purposes outlined in this policy:
                        <br />
                        • Account data: Until account deletion plus 30 days
                        <br />
                        • Communication records: 3 years from last contact
                        <br />
                        • Technical logs: 12 months
                        <br />
                        • Marketing data: Until consent is withdrawn
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        8. Your Rights Under GDPR
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        As a data subject, you have the following rights:
                        <br />
                        • Right of access: Request copies of your personal data
                        <br />
                        • Right to rectification: Request correction of inaccurate data
                        <br />
                        • Right to erasure: Request deletion of your personal data
                        <br />
                        • Right to restrict processing: Limit how we process your data
                        <br />
                        • Right to data portability: Receive your data in a portable format
                        <br />
                        • Right to object: Object to processing based on legitimate interests
                        <br />
                        • Right to withdraw consent: Withdraw consent at any time
                        <br />
                        • Right to lodge a complaint: Contact your local data protection authority
                    </Typography>

                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        To exercise these rights, contact us at contact@eternity.ac. We will respond within 30 days.
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        9. Cookies and Tracking Technologies
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        We use cookies and similar technologies as described in our Cookie Policy. You can manage your cookie preferences through our cookie consent banner or browser settings.
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        10. Data Security
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        We implement appropriate technical and organizational measures to protect your personal data:
                        <br />
                        • Encryption in transit and at rest
                        <br />
                        • Access controls and authentication
                        <br />
                        • Regular security assessments
                        <br />
                        • Staff training on data protection
                        <br />
                        • Incident response procedures
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        11. Data Breach Notification
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        In the event of a personal data breach that poses a high risk to your rights and freedoms, we will notify you within 72 hours of becoming aware of the breach, as required by Article 34 of the GDPR.
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        12. Children's Privacy
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        Our services are not intended for children under 16 years of age. We do not knowingly collect personal data from children under 16. If we become aware that we have collected personal data from a child under 16, we will delete such data promptly.
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        13. Changes to This Policy
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        We may update this Privacy Policy from time to time. We will notify you of any material changes by posting the new policy on our website and updating the "Last updated" date. Continued use of our services after changes constitutes acceptance of the updated policy.
                    </Typography>

                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#1e293b' }}>
                        14. Contact Information
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>
                        If you have any questions about this Privacy Policy or our data practices, please contact us:
                        <br />
                        Email: contact@eternity.ac
                        <br />
                        Subject line: "Privacy Policy Inquiry"
                        <br />
                        <br />
                        You also have the right to lodge a complaint with your local supervisory authority if you believe we have not handled your personal data in accordance with the GDPR.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
}